export const theme = {
  colors: {
    body: '#ebebeb',
    black: '#000',
    white: '#fff',
    red: '#ff0000',
    text: '#2a2a2a',
    background: '#fff',
    primary: '#07c',
    secondary: '#05a',
    header: {
      primary: '#000000',
      active: 'rgb(234, 47, 58)',
    },
    loaderColor: '#e50000',
    colorEmailNotification: '#f2f2f2',
    bgColorEmailNotification: '#0060af',

    transparent: 'transparent',
    secBgColorAsideBtn: '#3366ff',
    secBgColorHeaderBtn: 'rgba(51, 102, 255, 0.2)',
    secColorHeaderBtn: '#3366ff',
    bgcAside: 'rgb(51, 102, 255)',
  },
  space: [0, 2, 4, 8, 16, 32, 64, 128, 256],
  fonts: {
    body: 'system-ui, sans-serif',
    heading: 'system-ui, sans-serif',
    monospace: 'Menlo, monospace',
  },
  fontSizes: {
    xs: '14px',
    s: '16px',
    m: '18px',
    l: '20px',
    xl: '24px',
  },
  fontWeights: {
    normal: 400,
    preBold: 600,
    bold: 700,
  },
  lineHeights: {
    aside: 1.5,
    heading: 1.125,
  },
  borders: {
    none: 'none',
    normal: '1px solid',
  },
  radii: {
    none: '0',
    sm: '4px',
    md: '6px',
    lg: '10px',
    round: '50%',
  },
};
